export default "__VITE_PUBLIC_ASSET__eb9609de__"